import Index7 from "../pages/Interior/Index7";
import BlogList from "../pages/BlogList";
import BlogDetails from "../pages/BlogDetails";

const routes = [
  { path: "/", component: <Index7 /> },
  { path: "/blogs", component: <BlogList /> },
  { path: "/blogs/:id", component: <BlogDetails /> },
];

export { routes };
